<script setup>
import { computed } from 'vue';
import Avatar from 'next/avatar/Avatar.vue';

const props = defineProps({
  lead: {
    type: Object,
    required: true,
  },
});

const contactName = computed(
  () => props.lead.contact?.name || props.lead.contact?.email || '—'
);

const formattedDealValue = computed(() => {
  if (!props.lead.dealValue) return null;
  return new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  }).format(props.lead.dealValue);
});
</script>

<template>
  <div
    class="p-3 bg-n-solid-2 border border-n-weak rounded-lg cursor-grab active:cursor-grabbing hover:border-n-slate-6 transition-colors"
  >
    <div class="flex items-center gap-2 mb-2">
      <Avatar :src="lead.contact?.thumbnail" :size="24" :name="contactName" />
      <span class="text-sm font-medium text-n-slate-12 truncate">
        {{ contactName }}
      </span>
    </div>
    <div class="flex items-center justify-between text-xs text-n-slate-11">
      <span v-if="formattedDealValue">{{ formattedDealValue }}</span>
      <span v-else>&nbsp;</span>
      <Avatar
        v-if="lead.assignedAgent"
        :src="lead.assignedAgent.avatarUrl"
        :size="20"
        :name="lead.assignedAgent.name"
      />
    </div>
  </div>
</template>
